import { BasicQueryStringUtils } from '@openid/appauth';

export class QueryStringUtils extends BasicQueryStringUtils {
    parse(input, useHash) {
        return this.parseQueryString(input.search);
    }
}
